import React, { useState, useEffect } from 'react'

import RestrictionInputField from './RestrictionInputField'
import validator from 'validator';

const getHostName = url => {
    if (url.indexOf('//') > -1) {
        url = url.substring(url.indexOf('//') + 2)
    }
    var match = url.match(/(www[0-9]?\.)?(.[^/:]+)/i);
    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
    return match[2];
    }
    else {
        return null;
    }
}

const DomainManager = props => {
    const {
        restrictedDomains,
        clientID,
        eventID,
        actions
    } = props

    const [pending, setPending] = useState('')
    // const [request, setRequest] = useState({fetched:true, error:false})
    const [domains, setDomains] = useState(restrictedDomains || [])

    if (restrictedDomains === null && domains !== null && domains.length !== 0) {
        setDomains([])
    }

    useEffect(() => {
        if (restrictedDomains + '' !== domains + '') {
            setDomains(restrictedDomains || [])
        }
    }, [restrictedDomains])

    const handleRemove = index => {
        const tempDomains = [...domains]
        if (tempDomains === null) return

        let payload = {
            clientID,
            eventID
        }

        tempDomains.splice(index, 1)

        setDomains(tempDomains)
        if (tempDomains.length === 0) {
            actions.restrictedDomains.delete(payload)
        } else {
            payload.domains = tempDomains
            actions.restrictedDomains.add(payload)
        }
    }

    /*
        "clientID": "1000000000",
        "eventID": "2020011062",
        "domains": ["https://some.foo.com/somesite.html?&*@", "www.tvw.org"]
    */
   const handleAdd = (ev) => {
        ev.preventDefault()
        if (domains === null) setDomains([])
        let payload = {
            clientID,
            eventID,
            domains: [].
                concat(domains).
                concat([pending])
        }
        actions.restrictedDomains.add(payload)
        const tempPending = getHostName(pending) || pending
        setDomains([...domains, tempPending])
        setPending('')
    }
        /**
     *
     * @param {*} index Index in the Array
     * @param {*} value
     */
    const handleUpsert = (index, value) => {
        const updatedDomains = [...domains]
        updatedDomains[index] = value
        const payload = {
            clientID,
            eventID,
            domains: updatedDomains
        }
        actions.restrictedDomains.add(payload)
        setDomains(updatedDomains)
    }

    const render = () => {
        if (domains === null) setDomains([])

        return <div>
            <div className="row">
                <div className="col-xs-12">
                    <label htmlFor="">Domains Assigned:</label>
                </div>
                {!!domains && domains.length ?
                    domains.map((url, index) => {
                        return <RestrictionInputField
                            url={url}
                            index={index}
                            key={`${index}_${url}`}
                            handleUpsert={e => handleUpsert(index, e)}
                            handleRemove={e => handleRemove(index)}
                        />
                    }) :
                    <p className="col-xs-12">
                        <i>None Set</i>
                    </p>
                }
            </div>


            <hr style={{
                borderTop: "1px solid #d2d2d2"
            }}/>


            <div className="row">
                <div className="col-xs-12">
                    <label htmlFor="">New Domain to be Assigned:</label>
                </div>
                <div className="col-sm-10">
                    <input
                        type="text"
                        placeholder="Domain &hellip;"
                        className="form-control"
                        value={pending}
                        onChange={event => {
                            let { value } = event.target
                            setPending(value)       
                        }}
                    />
                </div>
                <div className="col-sm-2">
                    <button type="button"
                        disabled={
                            !validator.isURL(pending, {require_host: true}) ||
                            pending === '' ||
                            domains.indexOf(
                                pending
                            ) >= 0 ||
                            domains.includes(getHostName(pending))
                        }
                        className="btn btn-success"
                        onClick={handleAdd}
                    >
                        <i className="fa fa-plus"/> Add
                    </button>
                </div>
            </div>
        </div>
    }
    return render()
}

export default DomainManager